import React, { useState, useRef, useEffect } from "react"

import "./PatientProfile.css"
import "../Commons/Commons.css"
import "chart.js/auto"

import backarrow from "../../Assets/Icons/back-arrow.png"
import SidebarMenu from "../Sidebar/Sidebar"
import PatientCard from "./PatientCard"
import BtnSave from "../Commons/Buttons/BtnSave"
import Laboratory from "../Laboratory/Laboratory"
import AssessmentHistory from "../AssessmentHistory/AssessmentHistory"
import Radiology from "../Radiology/Radiology"
import Xray from "../Radiology/Xray"
import Ultrasound from "../Radiology/Ultrasound"
import CTScan from "../Radiology/CTScan"
import Others from "../Radiology/Others"
import HealthScreening from "../HealthScreening/HealthScreening"
import PatientScannedProfile from "../PatientScannedFiles/PatientScannedFiles"
import AddMedical from "../MedicalHistory/AddMedical"
import { createQueueSlipFile } from "../QueueSlip/QueueSlipUtils"
import QueueSlip from "../QueueSlip/QueueSlip"
import MedicalAbstract from "../Forms/MedicalAbstract/MedicalAbstract"
import MedicalSummary from "../Forms/MedicalSummary/MedicalSummary"
import TheraputicsHistory from "../Theraputics/TheraputicsHistory"
import LaboratoryResults from "../Laboratory/LaboratoryResults"
import MedicalChart from "../MedicalChart/MedicalChart"
import CheckupTabs from "../../Pages/CheckupTabs/CheckupTabs"
import { PhilHealthMedicalRecord } from "../PhilHealth/MedicalRecord"
import AddSocialPersonal from "../SocialPersonalHistory/AddSocialPersonal";
import AppointmentModal from "../Modals/AppointmentModal"
import AddToQueueModal from "../Modals/AddToQueueModal"
import RoutingSlipModal from "../Modals/RoutingSlipModal"
import VitalSigns from "./VitalSigns"
import PhysicalExaminationYakap from "../PEYakap/PhysicalExaminationYakap"
import DeleteModal from "../Modals/DeleteModal"
import MedicalCertificateForm from "../Forms/MedicalCertificate/MedicalCertificateForm"
import ReferralLetterForm from "../Forms/ReferralLetter/ReferralLetterForm"
import AllergyCard from "./AllergyCard"
import FormHistory from "../Forms/FormHistory/FormHistory"
import TableSpinner from "../../Components/TableSpinner/TableSpinner"
import { getLabCategoriesQR } from "../Helpers/API/QrDiagnosticsApi/QrDiagnosticsApi";
import LabResultPage from "../Laboratory/LabResultPage";
import BirForm from "../AssessmentHistory/PrintEkas";
import {
  getAssessmentForPrint,
  uploadEkasDocument,
} from "../Helpers/API/AssessmentApi/AssessmentApi";
import { generateAndPrintEkasPdf } from "../AssessmentHistory/printEkasPdf";
import { Alert, Row, Col, Modal, Button } from "react-bootstrap"
import BtnDelete from "../Commons/Buttons/BtnDelete"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { Card } from "antd"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import {
  deletePatient,
  getPatientID,
} from "../Helpers/API/PatientApi/PatientApi"
import { getAllDoctors } from "../Helpers/API/DoctorApi/DoctorApi"
import { createSchedule } from "../Helpers/API/FollowUpPatientsApi/FollowUpPatientsApi"
import { toast } from "react-toastify"
import {
  getQueuedPatients,
  setFPEDone,
  createBookings,
} from "../Helpers/API/QueueApi/QueueApi"
import { createPayment } from "../Helpers/API/PaymentApi/PaymentApi"
import {
  getIsCheck,
  getOpenAppointmentModal,
  getRole,
  getTomorrowDate,
  getUser,
  getAge,
} from "../Helpers/Utilities/Common"
import { getAssessmentHistory } from "../Helpers/API/AssessmentApi/AssessmentApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCircleExclamation,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons"
import {
  getAllergy,
  getPastMedicalHistory,
  getHeredofamilial,
  getObgyneHistory,
} from "../Helpers/API/MedicalHistoryApi/MedicalHistoryApi"
import { areHistoryRequirementsMet } from "./historyCompletion"
import {
  getMedicalHistorySummary,
  getSocialPersonalHistorySummary,
} from "../Helpers/API/ReportsApi/ReportsApi"
import { Tabs } from "antd"

const { TabPane } = Tabs

function PatientProfile() {
  const role = getRole()
  const openAppointment = getOpenAppointmentModal()
  const isCheck = getIsCheck()
  const targetDivRef = useRef(null)
  const laboratoryDivRef = useRef(null)
  const evaluationDivRef = useRef(null)
  const queueSlipRef = useRef(null)
  const navigateto = useNavigate()
  const { state } = useLocation()
  const { id } = useParams()
  const [selectedCheckUpTab, setSelectedCheckUpTab] = useState("checkup")
  const [showDelete, setShowDelete] = useState(false)
  const [showNoQueueModal, setShowNoQueueModal] = useState(false)
  const [skipQueueLoading, setSkipQueueLoading] = useState(false)
  const [showCheckupTabs, setShowCheckupTabs] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [patientDetails, setpatientDetails] = useState([])
  const [selectedTab, setSelectedTab] = useState("")
  const [selectedLabTab, setSelectedLabTab] = useState("laboratory")
  const [selectedFormTab, setSelectedFormTab] = useState("medical_cert")
  const [selectedPhilHealthTab, setSelectedPhilHealthTab] =
    useState("medical_record")
  const [isClicked, setIsClicked] = useState(false)
  const [showAppointmentModal, setShowAppointmentModal] = useState(false)
  const [showAddToQueueModal, setShowAddToQueueModal] = useState(false)
  const [selectedDoctor, setSelectedDoctor] = useState(null)
  const [doctors, setDoctors] = useState([])
  const [complaint, setComplaint] = useState("")
  const [hasPriorAssessment, setHasPriorAssessment] = useState(false)
  const [assessment, setAssessment] = useState({})
  const [queueInfo, setQueueInfo] = useState({})
  const [appointmentDate, setAppointmentDate] = useState(
    new Date(getTomorrowDate()).toISOString().split("T")[0]
  )
  const [isForConsultation, setIsForConsultation] = useState("no")
  const [hasQueued, setHasQueued] = useState(false)
  const [isQueueChecking, setIsQueueChecking] = useState(false)

  const [showRoutingSlipModal, setShowRoutingSlipModal] = useState(false)
  const [bookingResponse, setBookingResponse] = useState(null)
  const [enableAddToQueue, setEnableAddToQueue] = useState(false)
  const [printQueueNo, setPrintQueueNo] = useState("")
  const [isCreatingPayment, setIsCreatingPayment] = useState(false)
  const enableAddToQueueRef = useRef(false)
  const queueNoFromConsultRef = useRef(null)
  const queueIdFromConsultRef = useRef(null)
  const isSkipQueueFlowRef = useRef(false)
  const [canShowAddToQueue, setCanShowAddToQueue] = useState(false)
  const [queueActionDone, setQueueActionDone] = useState(false)

  const [showLabForm, setShowLabForm] = useState(false)
  const [labResultsRefreshKey, setLabResultsRefreshKey] = useState(0)
  const [allergyData, setAllergyData] = useState([])
  const [smokingData, setSmokingData] = useState([])
  const [showEvalForm, setShowEvalForm] = useState(false)
  const [addEvaluation, setAddEvaluation] = useState(null)
  const [autoOpenEvaluation, setAutoOpenEvaluation] = useState(false)
  const [labCategories, setLabCategories] = useState([])
  const [keepBirForm, setKeepBirForm] = useState(false);
  const [historyRequirementsMet, setHistoryRequirementsMet] = useState(false)

  async function checkHistoryCompletionStatus(patientSex) {
    const sex = patientSex ?? patientDetails?.sex
    const [
      medSummary,
      socialSummary,
      pastMed,
      heredofamilial,
      obgyne,
    ] = await Promise.all([
      getMedicalHistorySummary(id),
      getSocialPersonalHistorySummary(id),
      getPastMedicalHistory({ patient_id: id }),
      getHeredofamilial({ patient_id: id }),
      getObgyneHistory({ patient_id: id }),
    ])

    const medSummaryData = medSummary.data?.data || []
    const socialSummaryData = socialSummary.data?.data || []
    const pastMedRows = pastMed.data?.data || []
    const heredofamilialRows = heredofamilial.data?.data || []
    const obgyneRows = obgyne.data?.data || []

    setHistoryRequirementsMet(
      areHistoryRequirementsMet({
        sex,
        medSummaryData,
        socialSummaryData,
        pastMedRows,
        heredofamilialRows,
        obgyneRows,
      })
    )
  }

  const handleShowLabForm = (data) => {
    setShowLabForm(data)
  }
  const [medicalHistory] = useLocalStorage("medicalHistory", "")
  const [chiefComplaint] = useLocalStorage("chiefComplaint", "")
  const [showPrintEkasModal, setShowPrintEkasModal] = useState(false);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState([]);
  function handleEdit() {
    navigateto("/patients/edit/" + id)
  }

  async function handleDeletePatient() {
    const response = await deletePatient(id)
    if (response.data?.status === 200) {
      toast.success(response.data.data[0])
      setShowDelete(false)
      setTimeout(function () {
        navigateto("/patients")
      }, 1000)
    } else {
      toast.error(response.error.data.response)
    }
  }

  async function fetchPatient() {
    setIsLoading(true)
    if (!queueNoFromConsultRef.current) {
      setEnableAddToQueue(true)
      enableAddToQueueRef.current = true
      setHasQueued(false)
      setBookingResponse(null)
    }
    
    const response = await getPatientID(id, "", "")
    if (response?.data) {
      const patient = response?.data?.data[0]

      if (!patient) {
        console.warn("PatientProfile: no patient found for route id", id)
        setIsLoading(false)
        return
      }

      const address = [
        patient?.street,
        patient?.barangay,
        patient?.province,
        patient?.city,
        patient?.zip_code,
      ]
        .filter(Boolean)
        .join(", ")

      setpatientDetails({
        ...patient,
        address,
      })
    } else {
      setpatientDetails([])
    }
    setIsLoading(false)
  }

  const onSetAppointment = async () => {
    setIsClicked(true)
    const res = await createSchedule({
      patient_id: id,
      scheduled_on: appointmentDate,
      doctor_id: selectedDoctor !== null ? selectedDoctor : "",
    })
    if (res.data) {
      toast.success(res.data.message)
      setShowAppointmentModal(false)
    } else if (res.error) {
      toast.error(res.error.data.messages.error_messages[0])
    }
    setIsClicked(false)
  }

  const onAddToQueue = async (action, doctorId, masterDoctorId, doctorName) => {
    if (isClicked || (!enableAddToQueue && hasQueued)) return
    
    const currentQueueStr = localStorage.getItem("queue_id")
    const currentQueue = currentQueueStr ? JSON.parse(currentQueueStr) : null
    
    const queueIdToUse = queueIdFromConsultRef.current || currentQueue?.id || ""
    const queueNoToUse = queueNoFromConsultRef.current || currentQueue?.queue_no || ""
    
    if (action === "proceed") {
      setIsClicked(true)
      try {
        const queueRes = await createBookings({
          patient_id: id,
          doctor_id: doctorId,
          master_doctor_id: masterDoctorId,
          doctor_name: doctorName,
          queue_id: queueIdToUse,
        })
        
        if (queueRes?.data) {
          await setFPEDone({ patient_id: id, action: "" })
          
          localStorage.removeItem("queue_id")
          queueIdFromConsultRef.current = null
          queueNoFromConsultRef.current = null
          setEnableAddToQueue(false)
          enableAddToQueueRef.current = false
          setQueueActionDone(true)
          setQueueInfo({})
          
          toast.success(queueRes.data.message || "Patient queued successfully")
          setHasQueued(true)
          
          if (patientDetails?.master_patient_id) {
            try {
              window.localStorage.setItem(
                `csrQueued:${patientDetails.master_patient_id}`,
                JSON.stringify(true)
              )
            } catch (e) {}
          }
          
          setShowAddToQueueModal(false)
          
          const newBooking = {
            ...queueRes.data,
            doctor_name: doctorName,
            queue_no: queueRes?.data?.data?.queue_no || queueRes?.data?.queue_no || queueNoToUse,
            queue_id: queueIdToUse,
          }
          setBookingResponse(newBooking)

          if (state?.fromConsult) {
            setIsCreatingPayment(true)
            try {
              await handleCreatePayment("no", newBooking)
            } finally {
              setIsCreatingPayment(false)
            }
          } else {
            setShowRoutingSlipModal(true)
          }
        } else {
          toast.error(
            queueRes?.error?.data?.messages?.error_messages?.[0] ||
              queueRes?.response?.data?.messages?.error_messages?.[0] ||
              "An error occurred creating queue"
          )
        }
      } catch (error) {
        toast.error("An error occurred during queue process")
      }
      setIsClicked(false)
    } else if (action === "no") {

      try {
        await setFPEDone({ patient_id: id, action: "skip" })
        
        localStorage.removeItem("queue_id")
        queueIdFromConsultRef.current = null
        queueNoFromConsultRef.current = null
        setEnableAddToQueue(false)
        enableAddToQueueRef.current = false
        setQueueActionDone(true)
        setQueueInfo({})
        
        toast.success("Queue ended and FPE marked as done")
        setHasQueued(true)
        setShowAddToQueueModal(false)
      } catch (error) {
        toast.error("An error occurred")
      }
    }
  }

  const getTodayDateString = () => new Date().toISOString().split("T")[0];

  const findNestedField = (source, keys) => {
    if (!source || typeof source !== "object") return "";

    const stack = [source];

    while (stack.length) {
      const current = stack.pop();

      if (Array.isArray(current)) {
        current.forEach((item) => stack.push(item));
        continue;
      }

      if (!current || typeof current !== "object") continue;

      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(current, key)) {
          const value = current[key];
          if (value !== undefined && value !== null && value !== "") {
            return value;
          }
        }
      }

      Object.values(current).forEach((value) => {
        if (value && typeof value === "object") stack.push(value);
      });
    }

    return "";
  };

  const getBookingField = (...keys) => {
    const sources = [
      bookingResponse?.data?.data,
      bookingResponse?.data,
      bookingResponse,
    ];

    for (const source of sources) {
      const value = findNestedField(source, keys);
      if (value !== "") return value;
    }

    return "";
  };

  const getBookingAssessmentId = () => {
    const directId = getBookingField("assessment_id");
    if (directId) return directId;
    const assessment = getBookingField("assessment");
    if (assessment && typeof assessment === "object" && assessment.id) {
      return assessment.id;
    }
    return "";
  };

  const ekasCaseNumberKeys = [
    "phic_case_no",
    "phic_case_number",
    "case_no",
    "case_number",
    "phicCaseNo",
    "phicCaseNumber",
    "caseNo",
    "caseNumber",
    "philhealth_case_no",
    "philhealth_case_number",
  ];

  const applyEkasFallbackDefaults = (details, assessmentDetails = assessment) => {
    const base = details && typeof details === "object" ? { ...details } : {};
    const bookingTransactionNo = getBookingField("transaction_no");
    const bookingCaseNo = getBookingField(...ekasCaseNumberKeys);
    const baseTransactionNo = findNestedField(base, ["transaction_no", "transactionNo"]);
    const baseCaseNo = findNestedField(base, ekasCaseNumberKeys);
    const activeAssessmentCaseNo = findNestedField(assessmentDetails, ekasCaseNumberKeys);
    const patientCaseNo = findNestedField(patientDetails, ekasCaseNumberKeys);

    return {
      ...base,
      transaction_no: baseTransactionNo || bookingTransactionNo,
      phic_case_no:
        baseCaseNo || bookingCaseNo || activeAssessmentCaseNo || patientCaseNo,
    };
  };

  const getEkasCaseNumber = (details) =>
    findNestedField(details, ekasCaseNumberKeys);

  const uploadInitialEkasDocument = async () => {
    const formData = new FormData();
    formData.append("patient_id", id);
    formData.append("document_type", "Ekas");

    if(patientDetails.is_tranche_number_1 == 0) {
      const uploadResponse = await uploadEkasDocument(formData);
      const applicationStatus = Number(uploadResponse?.data?.status);
      const hasApplicationStatus =
        uploadResponse?.data?.status !== undefined &&
        uploadResponse?.data?.status !== null;
      if (
        uploadResponse?.error ||
        !uploadResponse?.data ||
        (hasApplicationStatus &&
          (applicationStatus < 200 || applicationStatus >= 300))
      ) {
        throw new Error(
          uploadResponse?.error?.data?.messages?.error_messages?.[0] ||
            uploadResponse?.data?.messages?.error_messages?.[0] ||
            uploadResponse?.data?.message ||
            "Unable to upload the initial eKas document."
        );
      }
    }
  };

  const loadEkasDetails = async (printPayload, assessmentDetails, waitForCaseNumber = false) => {
    const maxAttempts = waitForCaseNumber ? 10 : 1;
    let ekasDetails = {};

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const response = await getAssessmentForPrint(printPayload);
      if (response?.error) {
        throw new Error("Unable to load eKas details.");
      }

      ekasDetails = applyEkasFallbackDefaults(
        response?.data?.data ?? {},
        assessmentDetails
      );
      if (getEkasCaseNumber(ekasDetails)) return ekasDetails;

      if (attempt < maxAttempts - 1) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }

    return ekasDetails;
  };

  const openEkasPrintModal = async () => {
    try {
      const uploadToastId = toast.loading("Uploading initial eKas document...");
      await uploadInitialEkasDocument();
      toast.dismiss(uploadToastId);
    } catch (error) {
      toast.dismiss();
      setKeepBirForm(false);
      console.error(error);
      toast.error(error.message || "Unable to upload the initial eKas document.");
      return false;
    }

    let ekasDetails;
    try {
      ekasDetails = await loadEkasDetails({ patient_id: id }, assessment);
    } catch (err) {
      setKeepBirForm(false);
      console.error(err);
      toast.error("Unable to load eKas details");
      return false;
    }

    setSelectedPatientDetails(ekasDetails);
    setTimeout(() => {
      setShowPrintEkasModal(true);
    }, 300);
    return true;
  };

  const handlePostEkasFlow = async () => {
    setKeepBirForm(false);
    if (isSkipQueueFlowRef.current) {
      isSkipQueueFlowRef.current = false;
      setHasQueued(true);
      navigateto("/dashboard");
      return;
    }
    setIsCreatingPayment(true);
    try {
      await handleCreatePayment("no");
    } finally {
      setIsCreatingPayment(false);
    }
  };

  const handleRoutingSlipPrintDone = async () => {
    setShowRoutingSlipModal(false);
    isSkipQueueFlowRef.current = false;
    await openEkasPrintModal();
  };

  const handlePrintEkasThenPayment = async () => {
    setShowPrintEkasModal(false);
    setIsCreatingPayment(true);
    try {
      await handleCreatePayment("no");
    } finally {
      setIsCreatingPayment(false);
    }
  };

  const handleSkipQueueConfirm = async () => {
    setSkipQueueLoading(true);
    try {
      const fpeRes = await setFPEDone({ patient_id: id, action: "skip" });
      if (fpeRes?.error) {
        throw new Error(
          fpeRes?.error?.data?.messages?.error_messages?.[0] ||
            "Unable to mark FPE as done."
        );
      }

      localStorage.removeItem("queue_id");
      queueIdFromConsultRef.current = null;
      queueNoFromConsultRef.current = null;
      setEnableAddToQueue(false);
      enableAddToQueueRef.current = false;
      setQueueActionDone(true);
      setQueueInfo({});

      toast.success("FPE marked as done");
      setShowNoQueueModal(false);
      setHasQueued(true);
      isSkipQueueFlowRef.current = true;

      const ekasReady = await openEkasPrintModal();
      if (!ekasReady) {
        isSkipQueueFlowRef.current = false;
        navigateto("/dashboard");
      }
    } catch (error) {
      console.error(error);
      isSkipQueueFlowRef.current = false;
      toast.error(error?.message || "An error occurred. Please try again.");
    } finally {
      setSkipQueueLoading(false);
    }
  };

  const handleCreatePayment = async (additionalTransaction, bookingData = bookingResponse) => {
    setIsClicked(true)
    try {
      const bookings = bookingData?.data?.bookings || bookingData?.bookings || []
      const consultationBooking = bookings.find(item => 
        item.details_type === "consultation" || item.transaction_type === "consultation"
      )
      
      const items = consultationBooking ? [{
        name: `Consultation Fee ( ${consultationBooking.doctor_name || "Doctor"} )`,
        quantity: 1,
        price: consultationBooking.price || consultationBooking.amount || 0,
        amount: consultationBooking.price || consultationBooking.amount || 0,
      }] : []
      
      const totalAmount = items.reduce((sum, item) => sum + item.amount, 0)
      const transactionId = bookingData?.data?.transaction_id || bookingData?.transaction_id || ""
      const transactionNo = bookingData?.data?.transaction_no || bookingData?.transaction_no || ""
      const customerName = `${patientDetails?.first_name || ""} ${patientDetails?.middle_name || ""} ${patientDetails?.last_name || ""}`.trim()
      
      const paymentPayload = {
        patient_id: id,
        master_patient_id: patientDetails?.master_patient_id || "",
        transaction_id: transactionId,
        amount_and_types: [{ type: "cash", amount: 0.0 }],
        grand_total: 0.0,
        discount: 0.0,
        payment_discount: 0.0,
        change: 0.0,
        charge_to: "",
        is_senior: 0,
        is_pwd: 0,
        additional_transaction: additionalTransaction,
      }
      
      const paymentRes = await createPayment(paymentPayload)
      
      if (paymentRes?.data) {
        toast.success(paymentRes.data.message || "Queue successfully")
        
        const queueNo = paymentRes?.data?.emr_queue_no ||
                        paymentRes?.data?.emr_response?.queue_no ||
                        paymentRes?.data?.emr_response?.queue_number ||
                        paymentRes?.data?.queue_no || 
                        bookingData?.queue_no || 
                        queueInfo?.queue_number || 
                        queueNoFromConsultRef.current || 
                        ""
        
        if (additionalTransaction === "yes") {
          setEnableAddToQueue(true)
          enableAddToQueueRef.current = true
          setHasQueued(false)
        } else {
          setEnableAddToQueue(false)
          enableAddToQueueRef.current = false
          navigateto("/dashboard")
        }
      } else if (paymentRes?.error) {
        toast.error(
          paymentRes?.error?.data?.messages?.error_messages?.[0] || "An error occurred creating payment"
        )
      }
    } catch (error) {
      toast.error("An error occurred during payment creation")
    }
    setIsClicked(false)
  }

  async function fetchAssessmentHistory(data) {
    const res = await getAssessmentHistory({
      patient_id: id,
      ...data,
    })
    if (res.data) {
      setAssessment(res.data.data[0])
    } else if (res.error) {
      setAssessment({})
    }
  }

  async function checkIfPatientHasPriorAssessment() {
    const res = await getAssessmentHistory({
      patient_id: id,
    })
    if (res.data) {
      if (res.data.data.length > 0) {
        setHasPriorAssessment(true)
      } else {
        setHasPriorAssessment(false)
      }
    } else if (res.error) {
      setHasPriorAssessment(false)
    }
  }

  async function fetchQueueNumber() {
    setIsQueueChecking(true)
    if (state?.fromConsult) {
      setQueueInfo({})
      setHasQueued(false)
      setIsQueueChecking(false)
      return
    }
    const res = await getQueuedPatients({
      status: "queued",
      patient_id: id,
    })
    if (res?.data?.data?.length > 0) {
      setQueueInfo(res.data.data[0])
      if (!enableAddToQueueRef.current) {
        setHasQueued(true)
      }
      setIsQueueChecking(false)
      return
    }
    const res2 = await getQueuedPatients({
      status: "queued",
      patient_id: id,
      is_phic_member: 1,
    })
    if (res2?.data?.data?.length > 0) {
      setQueueInfo(res2.data.data[0])
      if (!enableAddToQueueRef.current) {
        setHasQueued(true)
      }
      setIsQueueChecking(false)
      return
    }
    setQueueInfo({})
    try {
      const flag =
        patientDetails?.master_patient_id &&
        JSON.parse(
          window.localStorage.getItem(
            `csrQueued:${patientDetails.master_patient_id}`
          ) || "false"
        )
      if (flag && !enableAddToQueueRef.current) {
        setHasQueued(true)
      } else {
        setHasQueued(false)
      }
    } catch (e) {
      setHasQueued(false)
    }
    setIsQueueChecking(false)
  }

  async function fetchAllergy() {
    const response = await getAllergy({ patient_id: id })
    if (response.data) {
      setAllergyData(response.data.data)
    } else {
      setAllergyData([])
    }
  }

  async function fetchAllDoctors() {
    const response = await getAllDoctors()
    if (response.data) {
      const mappedDoctors = response.data.data.map((doctor) => ({
        label: doctor.doctor_name,
        value: doctor.id,
        id: doctor.id,
        doctor_name: doctor.doctor_name,
      }))
      setDoctors(mappedDoctors)
    } else {
      setDoctors([])
    }
  }

    async function fetchLabCategories() {
    const res = await getLabCategoriesQR();
    if (res.data) {
      const result = res.data.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
        tab_label: item.name.toLowerCase(),
      })).sort((a, b) => {
        const priority = { laboratory: 0, cardiology: 1 };
        return (priority[a.tab_label] ?? 2) - (priority[b.tab_label] ?? 2);
      });
      setLabCategories(result);
      if (result.length) {
        setSelectedLabTab(result[0].tab_label);
      }
    } else if (res.error) {
      setLabCategories([]);
    }
  }

  useEffect(() => {
    const isFromRegisterPatient = state?.fromRegisterPatient === true
    const isFromConsult = state?.fromConsult === true
    const isFromPhilhealthCheck = state?.fromPhilhealthCheck === true
    const hasQueueInfo = state?.queue_no && state?.queue_id
    
    if (isFromRegisterPatient || isFromConsult || isFromPhilhealthCheck) {
      setCanShowAddToQueue(true)
    } else {
      setCanShowAddToQueue(false)
    }
    
    if (hasQueueInfo) {
      queueNoFromConsultRef.current = state.queue_no
      queueIdFromConsultRef.current = state.queue_id
      setEnableAddToQueue(true)
      enableAddToQueueRef.current = true
      setHasQueued(false)
      setQueueInfo({})
    }
    
    fetchAllDoctors()
    checkIfPatientHasPriorAssessment()
    fetchPatient()
    fetchAllergy()
    fetchLabCategories()
    checkHistoryCompletionStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (id && patientDetails?.sex !== undefined) {
      checkHistoryCompletionStatus(patientDetails.sex)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, patientDetails?.sex])

  useEffect(() => {
    if (patientDetails?.master_patient_id && !queueNoFromConsultRef.current) {
      fetchQueueNumber()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientDetails?.master_patient_id])
  useEffect(() => {
    if (isCheck) {
      setShowCheckupTabs(true)
    }
    fetchAssessmentHistory({ status: "ongoing" })
    setShowAppointmentModal(openAppointment)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheck, openAppointment])

  useEffect(() => {
    if (!isLoading && showCheckupTabs) {
      targetDivRef.current?.scrollIntoView({ behavior: "smooth" })
    } else if (!isLoading && showLabForm) {
      laboratoryDivRef.current?.scrollIntoView({ behavior: "smooth" })
    } else if (!isLoading && showEvalForm) {
      evaluationDivRef.current?.scrollIntoView({ behavior: "smooth" })
    }
  }, [showCheckupTabs, showLabForm, showEvalForm, isLoading])

  function useLocalStorage(key, initialValue) {
    const [value, setValue] = useState(() => {
      try {
        const item = window.localStorage.getItem(key)
        return item ? JSON.parse(item) : initialValue
      } catch (error) {
        return initialValue
      }
    })

    useEffect(() => {
      window.localStorage.setItem(key, JSON.stringify(value))
    }, [key, value])

    return [value, setValue]
  }

  useEffect(() => {
    if (state?.fromConsult === true) {
      setSelectedTab("lab_results")
    } else {
      setSelectedTab("social_personal_history")
    }
  }, [state?.fromConsult])

  useEffect(() => {
    if (state?.fromQueueCheckUp) {
      setSelectedTab("assessment_history")
      setShowCheckupTabs(true)
    }
  }, [state])

  useEffect(() => {
    if (state?.selectedTab) {
      setSelectedTab(state.selectedTab)
    } else if (state?.openTab === "pe_history") {
      setSelectedTab(state?.fromConsult ? "physical_exam" : "social_personal_history")
    }
  }, [state?.openTab, state?.selectedTab, state?.fromConsult])

  useEffect(() => {
    if (
      chiefComplaint &&
      chiefComplaint !== "" &&
      medicalHistory === "medical_history"
    ) {
      setComplaint(chiefComplaint)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiefComplaint])

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  )

  const isYoungChild = patientDetails?.birthdate && getAge(patientDetails.birthdate) <= 5

  return (
    <div className="App">
      <SidebarMenu active={"Patients"} />
      {isLoading || isCreatingPayment ? (
        <div className="row p-5 pt-5 ps-3 mt-5 quill-cont">
          <TableSpinner />
        </div>
      ) : (
        <div className="col p-5 py-4 profile-container">
          <Row className="pt-2 p-3 patient-header">
            <Col xs={4} className="mt-2 patient-details">
              <Row>
                <Col xs={1}>
                  <img
                    src={backarrow}
                    alt="back"
                    className="backarrow"
                    width={25}
                    height={25}
                    onClick={() => navigateto(-1)}
                  ></img>
                </Col>
                <Col className="font-big font-bold ms-4 patient-details-title">
                  PATIENT DETAILS
                </Col>
              </Row>
            </Col>
            <Col xs={1}></Col>
            <Col className="">
              <Row className="profile-button buttons-payment">
                {!queueActionDone && (queueInfo.id || queueInfo.queue_number) && (
                  <Col className="header-btn">
                    <BtnSave
                      label={`Queue # ${queueInfo.queue_number}`}
                      disabled
                    />
                  </Col>
                )}
                <Col className="header-btn">
                  {canShowAddToQueue ? (
                    <BtnSave
                      label={"Add to Queue"}
                      onClick={() => setShowAddToQueueModal(true)}
                      disabled={                        
                      isClicked || 
                      isQueueChecking || 
                      queueActionDone ||
                      (!enableAddToQueue && hasQueued) ||
                      (!isYoungChild && !historyRequirementsMet)
                    }
                    />
                  ) : null}
                </Col>{patientDetails.is_tranche_number_1 == 0 && (
                  <Col className="header-btn bg-green">
                    <BtnSave
                      label={"Done"}
                      onClick={() => setShowNoQueueModal(true)}
                      disabled={
                        queueActionDone ||
                        (!isYoungChild && !historyRequirementsMet)
                      }
                    /> 
                  </Col>
                )}

                {role !== "nurse" && (
                  <Col className="header-btn">
                    {patientDetails?.assessment?.length !== 0 ? (
                      <BtnSave
                        label={"Cont. Check Up"}
                        onClick={() => {
                          setShowCheckupTabs(!showCheckupTabs)
                          setShowLabForm(false)
                          fetchAssessmentHistory({ status: "ongoing" })
                        }}
                      />
                    ) : (
                      <>
                        {medicalHistory === "" && (
                          <BtnSave
                            label={"Check Up"}
                            onClick={() => {
                              setShowCheckupTabs(!showCheckupTabs)
                              setShowLabForm(false)
                              fetchAssessmentHistory({ status: "ongoing" })
                            }}
                          />
                        )}
                      </>
                    )}
                  </Col>
                )}
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xl={2} className="profile-pic mb-4">
              <PatientCard
                patientDetails={patientDetails}
                onEditClick={handleEdit}
                onDeleteClick={() => setShowDelete(true)}
              />
              <AllergyCard allergyData={allergyData} />
            </Col>

            <Col
              xl={10}
              align="right"
              className="profile-tab card-container medical-summary-pdf"
            >
              <Tabs
                activeKey={selectedTab}
                id="PO-tabs"
                type="card"
                animated="true"
                size="large"
                onChange={(e) => {
                  setSelectedTab(e)
                }}
              >
                <TabPane
                  key="social_personal_history"
                  tab="Social/Personal History"
                >
                  {selectedTab === "social_personal_history" && (
                    <AddSocialPersonal
                      smokingDatas={smokingData}
                      setSmokingDatas={setSmokingData}
                      refreshHistoryCompletion={checkHistoryCompletionStatus}
                    />
                  )}
                </TabPane>
                <TabPane key="medical_history" tab="Medical History">
                  {selectedTab === "medical_history" && (
                    <AddMedical
                      allergyData={allergyData}
                      setAllergyData={setAllergyData}
                      refreshHistoryCompletion={checkHistoryCompletionStatus}
                      patientSex={patientDetails.sex}
                    />
                  )}
                </TabPane>
                <TabPane key="vital_signs" tab="Vital Signs">
                  {selectedTab === "vital_signs" && (
                    <VitalSigns
                      id={id}
                      sex={patientDetails.sex}
                      patientDetails={patientDetails}
                    />
                  )}
                </TabPane>
                <TabPane key="physical_exam" tab="Physical Exam">
                  {selectedTab === "physical_exam" && (
                    <PhysicalExaminationYakap
                      patientDetails={patientDetails}
                      viewOnly={true}
                    />
                  )}
                </TabPane>
                <TabPane key="health_screening" tab="Health Screening">
                  {selectedTab === "health_screening" && (
                    <HealthScreening patientId={id} />
                  )}
                </TabPane>
                {role !== "nurse" && (
                  <>
                    <TabPane key="assessment_history" tab="Assessments">
                      {selectedTab === "assessment_history" && (
                        <AssessmentHistory patientId={id} />
                      )}
                    </TabPane>
                  </>
                )}
                  <>
                    <TabPane key="lab_results" tab="Lab Results">
                      {selectedTab === "lab_results" && (
                        <LaboratoryResults
                          showEvalForm={(val) => setShowEvalForm(val)}
                          showLabForm={(val) => setShowLabForm(val)}
                          setShowCheckupTabs={(val) => setShowCheckupTabs(val)}
                          setAddEvaluation={(val) => setAddEvaluation(val)}
                          patientId={id}
                          autoOpenEvaluation={autoOpenEvaluation}
                          refreshKey={labResultsRefreshKey}
                        />
                      )}
                    </TabPane>
                  </>
                {role !== "nurse" && (
                  <>
                    <TabPane key="therapeutics" tab="Therapeutics">
                      {selectedTab === "therapeutics" && (
                        <TheraputicsHistory patientId={id} />
                      )}
                    </TabPane>
                  </>
                )}
                {role !== "nurse" && (
                  <>
                    <TabPane key="scanned_files" tab="Scanned Files">
                      {selectedTab === "scanned_files" && (
                        <PatientScannedProfile
                          patientId={id}
                          patientDetails={patientDetails}
                        />
                      )}
                    </TabPane>
                  </>
                )}
                {role !== "nurse" && (
                  <>
                    <TabPane key="forms" tab="Forms">
                      {selectedTab === "forms" && (
                        <Card>
                          {hasPriorAssessment ? (
                            <div style={{ minHeight: "100%" }}>
                              <div className="row">
                                <Tabs
                                  activeKey={selectedFormTab}
                                  id="PO-tabs"
                                  type="card"
                                  animated="true"
                                  size="large"
                                  onChange={(e) => {
                                    setSelectedFormTab(e)
                                  }}
                                >
                                  <TabPane
                                    key="medical_cert"
                                    tab="Medical Certificate"
                                  >
                                    {selectedFormTab === "medical_cert" && (
                                      <MedicalCertificateForm
                                        fileName={"MedicalCertificate.pdf"}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="referral_letter"
                                    tab="Referral Letter"
                                  >
                                    {selectedFormTab === "referral_letter" && (
                                      <ReferralLetterForm
                                        fileName={"ReferralLetter.pdf"}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="medical_abstract"
                                    tab="Medical Abstract"
                                  >
                                    {selectedFormTab === "medical_abstract" && (
                                      <MedicalAbstract
                                        id={id}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="medical_summary"
                                    tab="Medical Summary"
                                  >
                                    {selectedFormTab === "medical_summary" && (
                                      <MedicalSummary
                                        id={id}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="form_history"
                                    tab="Form History"
                                  >
                                    {selectedFormTab === "form_history" && (
                                      <FormHistory patientId={id} />
                                    )}
                                  </TabPane>
                                </Tabs>
                              </div>
                            </div>
                          ) : (
                            <Alert
                              variant="warning"
                              className="d-flex align-items-center"
                            >
                              <FontAwesomeIcon
                                fontSize={24}
                                icon={faCircleExclamation}
                              />
                              <span className="px-3">
                                Sorry, but you cannot generate medical forms for
                                a patient without prior assessment history.
                              </span>
                            </Alert>
                          )}
                        </Card>
                      )}
                    </TabPane>
                  </>
                )}
                <TabPane key="philhealth" tab="PhilHealth">
                  {selectedTab === "philhealth" && (
                    <Card>
                      <div style={{ minHeight: "100%" }}>
                        <div className="row">
                          <Tabs
                            activeKey={selectedPhilHealthTab}
                            id="PO-tabs"
                            type="card"
                            animated="true"
                            size="large"
                            onChange={(e) => {
                              setSelectedPhilHealthTab(e)
                            }}
                          >
                            <TabPane key="medical_record" tab="Medical Record">
                              {selectedPhilHealthTab === "medical_record" && (
                                <PhilHealthMedicalRecord
                                  patientDetails={patientDetails}
                                />
                              )}
                            </TabPane>
                          </Tabs>
                        </div>
                      </div>
                    </Card>
                  )}
                </TabPane>
                {role !== "nurse" && (
                  <>
                    <TabPane key="medical_chart" tab="Medical Chart">
                      {selectedTab === "medical_chart" && (
                        <MedicalChart patientDetails={patientDetails} />
                      )}
                    </TabPane>
                  </>
                )}
              </Tabs>
            </Col>
            {showCheckupTabs && role !== "nurse" && (
              <div ref={targetDivRef}>
                <CheckupTabs
                  assessment={assessment}
                  fetchAssessmentHistory={() =>
                    fetchAssessmentHistory({ status: "ongoing" })
                  }
                  complaint={state?.complaint || ""}
                  doctor_id={state?.doctor_id || ""}
                  selectedCheckUpTab={selectedCheckUpTab}
                  setSelectedCheckUpTab={setSelectedCheckUpTab}
                  patientDetails={patientDetails}
                  doctorOptions={doctors}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  selectedFormTab={selectedFormTab}
                  setSelectedFormTab={setSelectedFormTab}
                />
              </div>
            )}

            {showLabForm && selectedTab === "lab_results" && (
              <div
                ref={laboratoryDivRef}
                className="col card-container three-buttons-labaratory"
              >
                <Tabs
                  activeKey={selectedLabTab}
                  id="PO-tabs"
                  type="card"
                  size="large"
                  onChange={(e) => setSelectedLabTab(e)}
                >
                  {labCategories.map((data) => (
                    <TabPane key={data.tab_label} tab={data.name}>
                      <LabResultPage
                        id={id}
                        showLabForm={handleShowLabForm}
                        onLabSaved={() => setLabResultsRefreshKey((key) => key + 1)}
                        categoryData={data}
                      />
                    </TabPane>
                  ))}
                  <TabPane key="other" tab="OTHERS">
                    {selectedLabTab === "other" && (
                      <Others id={id} showLabForm={handleShowLabForm} />
                    )}
                  </TabPane>
                </Tabs>
              </div>
            )}
          </Row>
        </div>
      )}
      <AppointmentModal
        title={`Set Appointment Date`}
        show={showAppointmentModal}
        onHide={() => setShowAppointmentModal(false)}
        doctorsData={doctors}
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor}
        onConfirm={onSetAppointment}
        defaultDate={appointmentDate}
        setRescheduledDate={setAppointmentDate}
        saveTitle={`Save`}
        isClicked={isClicked}
      />
      <AddToQueueModal
        patientId={id}
        show={showAddToQueueModal}
        onHide={() => setShowAddToQueueModal(false)}
        onConfirm={onAddToQueue}
        isClicked={isClicked}
      />
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={"Do you want to delete this patient?"}
        onDelete={handleDeletePatient}
        isClicked={isClicked}
      />
      <Modal
        show={showNoQueueModal}
        onHide={() => !skipQueueLoading && setShowNoQueueModal(false)}
        centered
      >
        <Modal.Body className="text-center p-4">
          <div
            className="d-flex align-items-center justify-content-center mx-auto mb-3"
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "#fff4e0",
              color: "#f59e0b",
            }}
          >
            <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
          </div>
          <p className="mb-4" style={{ fontSize: "1.05rem" }}>
            Are you sure you will not proceed to queue?
          </p>
          <div className="d-flex gap-3">
            <Button
              variant="outline-warning"
              className="flex-fill"
              onClick={handleSkipQueueConfirm}
              disabled={skipQueueLoading}
            >
              {skipQueueLoading ? "Processing..." : "OK"}
            </Button>
            <Button
              variant="secondary"
              className="flex-fill"
              onClick={() => setShowNoQueueModal(false)}
              disabled={skipQueueLoading}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <RoutingSlipModal
        show={showRoutingSlipModal}
        onHide={() => setShowRoutingSlipModal(false)}
        customerDetail={patientDetails}
        allBooking={bookingResponse?.data?.bookings || bookingResponse?.bookings || []}
        bookingData={bookingResponse || {}}
        transactionNo={bookingResponse?.data?.transaction_no || bookingResponse?.transaction_no || ""}
        queueNo={queueInfo?.queue_no || ""}
        onPrintDone={handleRoutingSlipPrintDone}
        isLoading={isCreatingPayment}
      />

      <Modal
        show={showPrintEkasModal}
        onHide={null}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>Print eKas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Print the eKas form for this patient.</p>
        </Modal.Body>
        <Modal.Footer>
          <BtnSave
            label="Print eKas"
            size="sm"
            onClick={async () => {
              let ekasDetails = selectedPatientDetails;
              if (!getEkasCaseNumber(ekasDetails)) {
                const assessmentId =
                  ekasDetails?.assessment_id ||
                  ekasDetails?.assessment?.id ||
                  getBookingAssessmentId() ||
                  assessment?.id ||
                  findNestedField(patientDetails?.assessment, ["id"]);

                try {
                  ekasDetails = await loadEkasDetails(
                    {
                      patient_id: id,
                      ...(assessmentId && { assessment_id: assessmentId }),
                    },
                    assessment,
                    true
                  );
                } catch (err) {
                  console.error(err);
                  toast.error("Unable to refresh eKas details. Please try again.");
                  return;
                }

                if (!getEkasCaseNumber(ekasDetails)) {
                  toast.error("Case number is still being saved. Please try again in a moment.");
                  return;
                }

                if (assessmentId && !ekasDetails.assessment_id) {
                  ekasDetails.assessment_id = assessmentId;
                }
                setSelectedPatientDetails(ekasDetails);
              }

              setKeepBirForm(true);
              setShowPrintEkasModal(false);

              await new Promise(resolve => setTimeout(resolve, 500));

              const element = document.getElementById("printablediv");

              if (!element || element.innerHTML.trim().length < 100) {
                toast.error("eKas content not ready. Please try again.");
                setKeepBirForm(true);
                setShowPrintEkasModal(true);
                return;
              }

              try {
                const loadingToastId = toast.loading("Generating eKas PDF...");

                const pdfBlob = await generateAndPrintEkasPdf(element);
                toast.dismiss(loadingToastId);

                toast.loading("Uploading eKas...");
                const formData = new FormData();
                formData.append("file", pdfBlob, "ekas.pdf");
                formData.append("patient_id", id);
                formData.append("document_type", "Ekas");

                if(patientDetails.is_tranche_number_1 == 0) {
                  const uploadRes = await uploadEkasDocument(formData);
                  const uploadStatus = Number(uploadRes?.data?.status);
                  const hasUploadStatus =
                    uploadRes?.data?.status !== undefined &&
                    uploadRes?.data?.status !== null;
                  if (
                    uploadRes?.error ||
                    !uploadRes?.data ||
                    (hasUploadStatus &&
                      (uploadStatus < 200 || uploadStatus >= 300))
                  ) {
                    throw new Error(
                      uploadRes?.error?.data?.messages?.error_messages?.[0] ||
                        uploadRes?.data?.messages?.error_messages?.[0] ||
                        uploadRes?.data?.message ||
                        "Failed to upload the completed eKas document."
                    );
                  }
                }
                toast.dismiss();
                toast.success("eKas uploaded successfully");

              } catch (err) {
                toast.dismiss();
                toast.error(err.message || "Failed to process eKas");
                console.error(err);
                setKeepBirForm(true);
                setShowPrintEkasModal(true);
                return;
              }

              setKeepBirForm(false);

              await handlePostEkasFlow();
            }}
          />
        </Modal.Footer>
      </Modal>

      <div
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: `${506}px`,
          overflow: "hidden",
          pointerEvents: "none",
        }}
        aria-hidden="true"
      >
        {(showPrintEkasModal || keepBirForm) && (
          <BirForm data={selectedPatientDetails} />
        )}
      </div>
      <div style={{ position: "absolute", left: "-9999px", top: "-9999px", width: "520px" }}>
        <div ref={queueSlipRef} style={{ width: "520px" }}>
          <QueueSlip
            transaction_id=""
            emr_queue_no={printQueueNo}
            isCsr={true}
          />
        </div>
      </div>
    </div>
  )
}

export default PatientProfile